export default {
    path: "/predictions",
    name: "predictions",
    children: [
        {
            path: "",
            name: "predictions",
            component: () => import('@/views/Predictions/Index.vue')
        },
        {
            path: ":prediction/:period",
            name: 'prediction',
            component: () => import('@/views/Predictions/Prediction.vue')
        }
    ]
}
